// The contact people of a client or a lead (migration 071), edited as a list: each with a
// name, phone, email and role or note, one of them the main contact.
//
// One component for the three places they are edited — the client form, the lead form
// and the client card's contacts dialog — so the rules read the same everywhere. The rows
// are the dialog's state (utils/contacts); this renders them and reports each change.
//
// The main contact is a radio: exactly one at a time, which is the server's rule too. It
// is the one the lists, the leads board and the bell show.
import { useId } from 'react';
import he from '../i18n/he';
import Button from './Button';
import { TextInput } from './Form';
import {
  addContact, removeContact, setMain, updateContact, needsDetail,
} from '../utils/contacts';

const t = he.clients;

export default function ContactsEditor({ contacts, onChange }) {
  const group = useId();
  const field = (k, name) => (e) => onChange(updateContact(contacts, k, name, e.target.value));

  return (
    <fieldset className="contacts-editor">
      <legend>{t.contacts}</legend>
      {contacts.map((c, i) => (
        <div key={c.key} className="contact-edit">
          <div className="contact-edit-head">
            <label className="contact-main">
              <input
                type="radio"
                name={`${group}-main`}
                checked={c.is_main}
                onChange={() => onChange(setMain(contacts, c.key))}
              />
              {t.mainContact}
            </label>
            {contacts.length > 1 && (
              <Button small variant="subtle" onClick={() => onChange(removeContact(contacts, c.key))}>
                {t.removeContact}
              </Button>
            )}
          </div>
          <div className="contact-edit-fields">
            <TextInput label={t.contactName} value={c.name} onChange={field(c.key, 'name')} id={`${group}-n${i}`} />
            <TextInput label={t.contactRole} value={c.role} onChange={field(c.key, 'role')} id={`${group}-r${i}`} />
            <TextInput label={t.phone} type="tel" value={c.phone} onChange={field(c.key, 'phone')} id={`${group}-p${i}`} />
            <TextInput label={t.email} type="email" value={c.email} onChange={field(c.key, 'email')} id={`${group}-e${i}`} />
          </div>
          {needsDetail(c) && <p className="field-error">{t.contactNeedsDetail}</p>}
        </div>
      ))}
      <Button small variant="ghost" onClick={() => onChange(addContact(contacts))}>{t.addContact}</Button>
    </fieldset>
  );
}
